<!-- Estilos: src/assets/styles/components/_liga-ui.scss (sistema .lx-*) y _liga-b.scss (.lxb-*). -->
<section class="lx-pagina lx-pagina--con-cta" lang="es">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono lx-hero__icono--navy" aria-hidden="true"><fa-icon [icon]="iconos.equipo"></fa-icon></span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">Lo revisa nuestro equipo</span>
        <h2 class="lx-hero__titulo">{{titulo}}</h2>
        <p class="lx-hero__subtitulo">{{subtitulo}}</p>
        <span class="lx-chip" *ngIf="data.comment" [ngClass]="estados.corrige.chip">
          <fa-icon *ngIf="estados.corrige.icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estados.corrige.texto}}
        </span>
      </div>
    </div>
  </header>

  <div class="lx-alerta lx-alerta--error" *ngIf="data.comment">
    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
    <div class="lx-alerta__cuerpo">
      <p class="lx-alerta__titulo">Necesitamos que revises algo</p>
      <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
    </div>
  </div>

  <!-- Lo que dice la configuración del paso -->
  <article class="lx-tarjeta lx-pila" *ngIf="settings.description || (settings.img && !imagenFallo)">
    <img class="lxb-ilustracion" *ngIf="settings.img && !imagenFallo" [src]="settings.img" alt="" loading="lazy" (error)="imagenFallo = true">
    <p class="lxb-texto" *ngIf="settings.description">{{settings.description}}</p>
  </article>

  <section class="lx-tarjeta" aria-labelledby="lxb-manual-sigue">
    <div class="lx-tarjeta__cabeza">
      <h3 class="lx-tarjeta__titulo" id="lxb-manual-sigue">¿Qué sigue?</h3>
    </div>
    <ol class="lx-lista lx-lista--numerada">
      <li>Vuelve a tus pasos con el botón de abajo y sigue con lo que te falte.</li>
      <li>Nuestro equipo revisa este paso; no tienes que subir nada más.</li>
      <li>Si necesitamos algo, te avisamos para que lo completes.</li>
    </ol>
  </section>

  <p class="lx-seguro lx-seguro--ayuda">
    <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.ayuda"></fa-icon></span>
    <span>¿Tienes dudas sobre este paso? Tu asesor te puede ayudar.</span>
  </p>
</section>

<div class="lx-cta-fijo">
  <button type="button" class="lx-btn lx-btn--primario" (click)="entendido()"><span>Entendido, volver a mis pasos</span></button>
</div>
